import React from 'react';

import Tabs from 'brandComponents/Tabs';

import {ITabsContentfulProps} from './ITabsContentful';
import {TabContentful} from './Subcomponents';

const TabsContentful = (props: ITabsContentfulProps) => {
	// Prepare the element attributes
	const {kind, sideComponent, children} = props;
	const itemsList = props.itemsCollection?.items || [];
	let kindSlugified: string = '';

	if (kind) {
		kindSlugified = kind
			.toLowerCase()
			.trim()
			.replace(/[^\w\s-]/g, '')
			.replace(/[\s_-]+/g, '-')
			.replace(/^-+|-+$/g, '');
	}

	return (
		<Tabs items={itemsList} sideComponent={sideComponent} classNames={kindSlugified}>
			{children}
		</Tabs>
	);
};

TabsContentful.Tab = TabContentful;

export default TabsContentful;
